// @flow
import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classnames from 'classnames';
import {pad} from '../../../utils';

const getValue = (type, date) => (date ? pad(date[type]()) : '--');

const useStyles = makeStyles({
    root: {
        whiteSpace: 'nowrap',
        fontFamily: '"Roboto Mono", monospace',
        letterSpacing: '-0.5px'
    },
});

const defaultConfig = {
    hoursFnName: 'getHours',
    minutesFnName: 'getMinutes',
    secondsFnName: 'getSeconds'
};

export type Props = $ReadOnly<{
    date: ?Date,
    dateString?: string,
    config?: {
        hoursFnName?: string,
        minutesFnName?: string,
        secondsFnName?: string,
    },
    className?: string,
}>;

function Time({date, dateString, config = defaultConfig, className}: Props) {
    const classes = useStyles();

    const _date = date || (dateString && new Date(dateString));

    return (
        <span className={classnames(classes.root, className)}>
            {getValue(config.hoursFnName, _date)}:{getValue(config.minutesFnName, _date)}:{getValue(config.secondsFnName, _date)}
        </span>
    );
}

export default Time;